export const iconFontAwesomeMathematicsSquareMinus = (
	<i className="fa-solid fa-square-minus"></i>
);
